"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valuesToSchema = valuesToSchema;
exports.schemaToAttributes = schemaToAttributes;
exports.valueToSchema = valueToSchema;
exports.sumType = sumType;
const utils_1 = require("@azimutt/utils");
function valuesToSchema(values) {
    if (values.length > 0) {
        return sumSchema(values.map(valueToSchema));
    }
    else {
        return valueToSchema(undefined);
    }
}
// flatten: how many top level should be flattened
function schemaToAttributes(schema, flatten = 0, path = []) {
    // TODO: if string with few values (< 10% of docs), handle it like an enum and add values in comment
    if (schema.nested && flatten > 0) {
        return Object.entries(schema.nested).flatMap(([key, value]) => {
            return [(0, utils_1.removeUndefined)({
                    name: path.map(p => p + '.').join('') + key,
                    type: value.type,
                    null: value.nullable
                }), ...schemaToAttributes(value, flatten - 1, [...path, key])];
        });
    }
    else if (schema.nested) {
        return Object.entries(schema.nested).flatMap(([key, value]) => {
            const name = path.map(p => p + '.').join('') + key;
            return [(0, utils_1.removeUndefined)({
                    name,
                    type: value.type,
                    null: value.nullable,
                    attrs: value.nested ? schemaToAttributes(value) : undefined
                })];
        });
    }
    else {
        return [];
    }
}
// 👇️ Private functions, some are exported only for tests
// If you use them, beware of breaking changes!
function valueToSchema(value) {
    if (Array.isArray(value) && value.length > 0) {
        const schemas = value.map(valueToSchema);
        return cleanSchema({
            type: sumType(schemas.map(s => s.type)) + '[]',
            values: schemas.flatMap(s => s.values),
            nullable: false,
            nested: mergeNested(schemas.map(s => s.nested || {}))
        });
    }
    else if (typeof value === 'object' && value !== null && value.constructor.name === 'Object') {
        return cleanSchema({
            type: getType(value),
            values: [value],
            nullable: isNullable(value),
            nested: (0, utils_1.mapValues)(value, valueToSchema)
        });
    }
    else if (isNullable(value)) {
        return { type: getType(value), values: [], nullable: true };
    }
    else {
        return { type: getType(value), values: [value] };
    }
}
function mergeNested(items) {
    const nested = {};
    items.forEach(i => Object.entries(i).forEach(([key, schema]) => {
        nested[key] = nested[key] ? [...nested[key], schema] : [schema];
    }));
    // TODO: if more than 10 keys, they are all integers or uuids or have the same size or are hex values & have the same type inside => treat this as record instead of object
    return (0, utils_1.mapValues)(nested, sumSchema);
}
function sumSchema(schemas) {
    return cleanSchema({
        type: sumType(schemas.map(s => s.type).filter(t => t !== 'null')) || 'null',
        values: schemas.flatMap(s => s.values),
        nullable: schemas.reduce((acc, schema) => schema.nullable || false || acc, false),
        nested: mergeNested(schemas.map(s => s.nested || {}))
    });
}
function cleanSchema(schema) {
    const res = { type: schema.type, values: schema.values };
    if (schema.nested && Object.keys(schema.nested).length > 0) {
        res.nested = schema.nested;
    }
    if (schema.nullable) {
        res.nullable = schema.nullable;
    }
    return res;
}
function getType(value) {
    if (value === undefined || value === null) {
        return 'null';
    }
    else if (Array.isArray(value)) {
        return value.length > 0 ? sumType(value.map(getType)) + '[]' : '[]';
    }
    else if (typeof value === 'object') {
        return value.constructor.name;
    }
    else {
        return typeof value;
    }
}
function sumType(types) {
    types = (0, utils_1.distinct)(types);
    types = types.some(t => t !== '[]' && t.endsWith('[]')) ? types.filter(t => t !== '[]') : types;
    return types.map(t => t.indexOf('|') === -1 ? t : `(${t})`).join('|');
}
function isNullable(value) {
    return value === null || value === undefined;
}
//# sourceMappingURL=inferSchema.js.map